import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { RiskScoreModel } from '@lmsModels';
import { LmsModalFrameComponent } from '@lmsSharedUI';

import { RiskScoresService } from '../risk-scores.service';

@Component({
  selector: 'app-risk-score-remove-dialog',
  templateUrl: './risk-score-remove-dialog.component.html',
  styleUrls: ['./risk-score-remove-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, LmsModalFrameComponent],
})
export class RiskScoreRemoveDialogComponent implements OnInit {
  riskScoreModel: RiskScoreModel = new RiskScoreModel();
  riskScorecardInfo: any;
  submitted: boolean = false;

  constructor(
    public dialogRef: MdbModalRef<RiskScoreRemoveDialogComponent>,
    public riskScoreService: RiskScoresService
  ) {
    // Data is injected via modalRef.data
    const data = (this.dialogRef as any).data;
    this.riskScorecardInfo = data?.riskScorecard;
  }

  ngOnInit(): void {
   }

  removeScoreCardConfirmation() {
    this.submitted = true;
    let isValidData = true;

    if (this.riskScorecardInfo.id == null) {
      isValidData = false;
      console.log('Form data is invalid...');
    }

    if (isValidData) {
      return this.dialogRef.close(this.riskScoreModel);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
